// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--5-1!./ToastContainer.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = require("!../../node_modules/iso-morphic-style-loader/lib/addUniversalStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
module.exports.__universal__ = update.__universal__;
// Hot Module Replacement
if(module.hot && typeof window === 'object' && window.document) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--5-1!./ToastContainer.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--5-1!./ToastContainer.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}